import { FavouriteState } from '../slice';

const resetHighlightsReducer = (state: FavouriteState) => {
  state.highlights = [];
};

export default resetHighlightsReducer;
